export default {
      id: "print-usage",
      viewBox: "0 0 20 20",
      url: "/" + "sprite.svg#print",
      toString: function () {
        return this.url;
      }
    }